import * as Types from "../Constants/AllConstants";

// Paginated permissions
export const UserPermissionsReducer = (
  state = { permissions: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.USER_PERMISSIONS_REQUEST:
      return { ...state, loading: true };
    case Types.USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload.content || [],
        pageInfo: action.payload, // keep pagination metadata
      };
    case Types.USER_PERMISSIONS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// All permissions (non-paginated)
export const AllUserPermissionsReducer = (
  state = { allPermissions: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.USER_PERMISSIONS_ALL_REQUEST:
      return { ...state, loading: true };
    case Types.USER_PERMISSIONS_ALL_SUCCESS:
      return { ...state, loading: false, allPermissions: action.payload || [] };
    case Types.USER_PERMISSIONS_ALL_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Assign single
export const AssignPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ASSIGN_PERMISSION_REQUEST:
      return { loading: true };
    case Types.ASSIGN_PERMISSION_SUCCESS:
      return { loading: false, success: true, assigned: action.payload };
    case Types.ASSIGN_PERMISSION_FAIL:
      return { loading: false, error: action.payload };
    case Types.ASSIGN_PERMISSION_RESET:
      return {};
    default:
      return state;
  }
};

// Assign bulk
export const AssignBulkPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ASSIGN_BULK_PERMISSION_REQUEST:
      return { loading: true };
    case Types.ASSIGN_BULK_PERMISSION_SUCCESS:
      return { loading: false, success: true, assignedBulk: action.payload };
    case Types.ASSIGN_BULK_PERMISSION_FAIL:
      return { loading: false, error: action.payload };
    case Types.ASSIGN_BULK_PERMISSION_RESET:
      return {};
    default:
      return state;
  }
};

// Revoke single
export const RevokePermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.REVOKE_PERMISSION_REQUEST:
      return { loading: true };
    case Types.REVOKE_PERMISSION_SUCCESS:
      return { loading: false, success: true };
    case Types.REVOKE_PERMISSION_FAIL:
      return { loading: false, error: action.payload };
    case Types.REVOKE_PERMISSION_RESET:
      return {};
    default:
      return state;
  }
};

// Revoke bulk
export const RevokeBulkPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.REVOKE_BULK_PERMISSION_REQUEST:
      return { loading: true };
    case Types.REVOKE_BULK_PERMISSION_SUCCESS:
      return { loading: false, success: true };
    case Types.REVOKE_BULK_PERMISSION_FAIL:
      return { loading: false, error: action.payload };
    case Types.REVOKE_BULK_PERMISSION_RESET:
      return {};
    default:
      return state;
  }
};

// Unassigned permissions
export const UnassignedPermissionsReducer = (
  state = { unassigned: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.UNASSIGNED_PERMISSIONS_REQUEST:
      return { ...state, loading: true };
    case Types.UNASSIGNED_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, unassigned: action.payload || [] };
    case Types.UNASSIGNED_PERMISSIONS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Unassigned client permissions
export const UnassignedClientPermissionsReducer = (
  state = { unassignedClient: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.UNASSIGNED_CLIENT_PERMISSIONS_REQUEST:
      return { ...state, loading: true };
    case Types.UNASSIGNED_CLIENT_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        unassignedClient: action.payload || [],
      };
    case Types.UNASSIGNED_CLIENT_PERMISSIONS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
